import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import copyToClipboard from 'copy-to-clipboard';

import { ButtonGroup } from '../../../../../../../components';
import { selectMediaExport } from '../../../../../../../store/modules/articles/selectors';
import { notify } from '../../../../../../../store/modules/notifications/actions';
import useStyles from '../styles';
import { getLargeVideoThumbnailUrl } from '../../../utils';
import { getUrlWithoutQuery } from '../../../../../../../utility/helpers';

const CopyVideoThumbnailLinkAction = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { media } = useSelector(selectMediaExport);

  const clickHandler = useCallback((isCurrentFrame: boolean = false) => {
    return () => {
      if (media && media.ref.video) {
        const { video } = media.ref;
        let url = getLargeVideoThumbnailUrl(video.ref.thumbnails || []);
        if (url) {
          if (isCurrentFrame && window.mediaPlayerRef) {
            const currentVideoTime = window.mediaPlayerRef.currentTime;
            if (currentVideoTime) {
              url = getUrlWithoutQuery(url);
              url += `?height=1080&width=1920&time=${currentVideoTime}&fit_mode=preserve`;
            }
          }
          if (copyToClipboard(url)) {
            dispatch(
              notify({
                type: 'info',
                icon: 'copy',
                message: 'Thumbnail URL copied.',
              }),
            );
          } else {
            dispatch(
              notify({
                type: 'error',
                icon: 'copy',
                message: 'Thumbnail URL copying failed.',
              }),
            );
          }
        }
      }
    }
  }, [dispatch, media]);

  if (media && media.ref.video) {
    const { video } = media.ref;
    if (video.ref.thumbnails && video.ref.thumbnails.length > 0) {
      const buttons = [
        {
          title: 'Copy',
          titleList: 'Copy link video thumbnail',
          onClick: clickHandler(),
          disabled: false,
        },
        {
          title: 'Copy',
          titleList: 'Copy link current frame thumbnail',
          onClick: clickHandler(true),
          disabled: false,
        },
      ];

      return (
        <ButtonGroup
          buttons={buttons}
          color="default"
          variant="text"
          className={classes.groupAction}
        />
      );
    }
  }

  return null;
};

export default CopyVideoThumbnailLinkAction;
